import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/public/Header";
import Hero from "../components/public/Hero";
import ExpertsSection from "../components/public/ExpertsSection";
import { CategoriesSection, HowItWorks, ResultsSection, MissionSection, InvestorsSection } from "../components/public/Sections";
import { Newsletter, Footer } from "../components/public/Footer";
import { EXPERTS, INVESTORS, CATEGORIES, SITE_SETTINGS } from "../mock/mock";
import { ensureData } from "../lib/api";
import { Toaster } from "../components/ui/toaster";

const Home = () => {
  const [search, setSearch] = useState("");
  const [experts, setExperts] = useState(EXPERTS);
  const [categories, setCategories] = useState(CATEGORIES);
  const [investors, setInvestors] = useState(INVESTORS);
  const [siteSettings, setSiteSettings] = useState(SITE_SETTINGS);
  const location = useLocation();

  useEffect(() => {
    ensureData(EXPERTS, SITE_SETTINGS, CATEGORIES, INVESTORS)
      .then(({ experts, categories, investors, settings }) => {
        if (experts?.length) setExperts(experts);
        if (categories?.length) setCategories(categories);
        if (investors?.length) setInvestors(investors);
        if (settings && Object.keys(settings).length) setSiteSettings((p) => ({ ...p, ...settings }));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash;
      const timer = setTimeout(() => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" }), 350);
      return () => clearTimeout(timer);
    }
  }, [location]);

  const pickCategory = (catId) => {
    setSearch("");
    const el = document.querySelector("#experts");
    el?.scrollIntoView({ behavior: "smooth" });
    window.dispatchEvent(new CustomEvent("intro:filter", { detail: catId }));
  };

  return (
    <div className="bg-white">
      <Header onSearch={setSearch} />
      <main>
        <Hero onSearch={setSearch} content={siteSettings.content} />
        <ExpertsSection experts={experts} searchQuery={search} />
        <CategoriesSection onPick={pickCategory} categories={categories} />
        <HowItWorks />
        <ResultsSection images={siteSettings.results} />
        <MissionSection content={siteSettings.content} />
        <InvestorsSection investors={investors} />
        <Newsletter />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Home;
